module.exports = __webpack_public_path__ + "static/media/gimac.e9f2c74e.svg";